export interface ILocalStorageCacheItem {
    cacheKey: string;
    item: any;
    timestamp: Date;
    globalKeys: string[];
}

export class GlobalCacheKeys {
    static User = "USER";
}

export class LocalStorageCache {
    // Singleton :/ Missing DI
    private static instance: LocalStorageCache;
    static getInstance() {
        if (LocalStorageCache.instance == null || LocalStorageCache.instance === undefined) {
            LocalStorageCache.instance = new LocalStorageCache();
        }
        return LocalStorageCache.instance;
    }

    // Contains all cache items, for fast lookup
    private cache: { [cacheKey: string]: ILocalStorageCacheItem } = {};

    // Contains global cache keys for invalidation
    private cacheGlobalKeys: { [globalCacheKey: string]: string[] } = {};

    private cacheTimeout = 60000 * 5; //Timeout set to be 5 minutes
    constructor() {
        this.loadCache();
    }


    getOrBuild<TObject>(cacheKey: string, builder: () => Promise<TObject>, globalCacheKeys: () => string[]): Promise<TObject> {
        return new Promise<TObject>((resolve, reject) => {
            const curTimestamp = new Date();
            const item = this.cache[cacheKey];
            if (item && (curTimestamp.getTime() - new Date(item.timestamp).getTime()) < this.cacheTimeout) {

                //Stringify and parses it to ensure that we get a deep copy so its never overriden.
                resolve(JSON.parse(JSON.stringify(item.item)));

            } else {
                builder().then((item: TObject) => {
                    let cacheItem: ILocalStorageCacheItem = {
                        cacheKey: cacheKey,
                        item: item,
                        timestamp: new Date(),
                        globalKeys: globalCacheKeys()
                    };
                    this.cache[cacheKey] = cacheItem;
                    for (let globalKey of cacheItem.globalKeys) {
                        // Find or build dictionary hit and push cache key
                        (this.cacheGlobalKeys[globalKey] || (this.cacheGlobalKeys[globalKey] = []))
                            .push(globalKey);

                    }
                    this.saveCache();

                    //Stringify and parses it to ensure that we get a deep copy so its never overriden.
                    resolve(JSON.parse(JSON.stringify(item)));
                })
                    .catch(e => () => {
                        reject(e);
                    }
                    );
            }
        });
    }

    /**
     * Removes all cached values with the given global cachekey.
     * @param cacheKey
     */
    public deletebyGlobalCacheKey(cacheKey: string): void {
        const self = this;
        for (let itemKey in this.cache) {
            const item = this.cache[itemKey] as ILocalStorageCacheItem;

            if (item.globalKeys) {
                for (let globalKey of item.globalKeys) {
                    if (globalKey === cacheKey) {
                        delete self.cache[itemKey];
                    }
                }
            }
        }
        this.saveCache();
    }

    deleteCacheByKey(cacheKey: string): void {
        delete this.cache[cacheKey];
        this.saveCache();
    };

    private loadCache() {
        // Populate cache
        if (!localStorage) return;

        const content = localStorage.getItem('LocalStorageCache');
        if (!content) return;

        const items = <ILocalStorageCacheItem[]>JSON.parse(content);
        for (let item of items) {
            this.cache[item.cacheKey] = item;
            if (item.globalKeys) {
                for (let globalKey of item.globalKeys) {
                    let keysRef = this.cacheGlobalKeys[globalKey] || (this.cacheGlobalKeys[globalKey] = []);
                    keysRef.push(item.cacheKey);
                }
            }
        }
    }

    private saveCache() {
        let items: ILocalStorageCacheItem[] = [];
        for (let itemKey in this.cache) {
            items.push(this.cache[itemKey]);
        }
        localStorage.setItem('LocalStorageCache', JSON.stringify(items));
    }
}